import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-white text-center py-4 text-sm">
      <p className="opacity-60">
        Sterling House, Maple Court, Tankersley, S75 3DP |{' '}
        <a href="https://www.ashadegreener.co.uk/privacy" target="_blank" rel="noopener noreferrer" className="hover:opacity-100">
          Privacy Policy
        </a>
      </p>
    </footer>
  );
};

export default Footer;